/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2LockIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2LockIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2LockIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2LockIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 style={{'--as-1-Z7cdIS': alignSelf,'--mt-2-Z7cdIS': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z7cdIS': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z7cdIS': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z7cdIS': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z7cdIS': opacity,'--w-10-Z7cdIS': typeof width === 'number' ? `${width}px` : width,'--h-11-Z7cdIS': typeof height === 'number' ? `${height}px` : height,'--f-12-Z7cdIS': fill,'--a-7-Z7cdIS': isAnimated ? animation : "none",'--sd-8-Z7cdIS': isAnimated ? strokeDashoffset : 0,'--sd-9-Z7cdIS': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2LockIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M16.286 10.286A2.286 2.286 0 0014 12.57v1.143h6.857c.947 0 1.714.768 1.714 1.715v6.857c0 .947-.767 1.714-1.714 1.714h-9.143A1.714 1.714 0 0110 22.286v-6.857c0-.947.768-1.715 1.714-1.715v-1.143a4.571 4.571 0 017.979-3.047 1.143 1.143 0 01-1.703 1.524 2.277 2.277 0 00-1.704-.762zm0 10a1.429 1.429 0 100-2.857 1.429 1.429 0 000 2.857z"
 style={{'--f-12-Z7cdIS': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}